import { v4 as uuidv4 } from "uuid";
import { buildCos, uploadFileToOss } from "@/utils/cos/cos";
import { appConfig } from "@/config/app-config";

/** 黑名单举证图片上传，返回 COS object key */
export function createBlacklistEvidenceUploader(uid: string) {
  return async (file: File, onProgress: (percent: number) => void): Promise<string> => {
    const extMatch = file.name.match(/(\.[^./\\]+)$/);
    const ext = extMatch ? extMatch[1] : "";
    const storageBase = `${Date.now()}_${uuidv4()}${ext}`;
    const fileKey = `temp/${uid}/${storageBase}`;
    const cos = buildCos(fileKey);
    await uploadFileToOss({
      cos,
      fileKey,
      file,
      bucket: appConfig.cos.tplBucket,
      region: appConfig.cos.tplBucketRegion,
      onProgress: (progressData) => {
        onProgress(Math.round(progressData.percent * 100));
      },
    });
    return fileKey;
  };
}
